// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"cddee7c0","221":"8c8644ff","223":"c0ed768a","238":"06c5e042","239":"02f26cce","455":"a0d5f404","488":"679423f4","586":"65df7790","633":"f66854b9","720":"b919c550","908":"ad664271","977":"4f5de726"}[chunkId] + ".chunk.js";
};